export default "__VITE_ASSET__DHIIRIsS__"